import { render, staticRenderFns } from "./OrderDraftItemBundleSelection.vue?vue&type=template&id=b08433e4&scoped=true&"
import script from "./OrderDraftItemBundleSelection.vue?vue&type=script&lang=js&"
export * from "./OrderDraftItemBundleSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08433e4",
  null
  
)

export default component.exports